export default [
    {
        path: '/pages/dev/transactionLogManage',
        name: '/pages/dev/transactionLogManage',
        component: () => import('@/views/dev/transactionLogManage.vue')
    },
    {
        path: '/pages/dev/serviceRegisterManage',
        name: '/pages/dev/serviceRegisterManage',
        component: () => import('@/views/dev/serviceRegisterManage.vue')
    },
    {
        path: '/pages/dev/sysDocumentManage',
        name: '/pages/dev/sysDocumentManage',
        component: () => import('@/views/dev/sysDocumentManage.vue')
    },
    {
        path: '/pages/dev/serviceManage',
        name: '/pages/dev/serviceManage',
        component: () => import('@/views/dev/serviceManage.vue')
    },
    {
        path: '/pages/dev/serviceProvideManage',
        name: '/pages/dev/serviceProvideManage',
        component: () => import('@/views/dev/serviceProvideManage.vue')
    },
    {
        path: '/pages/dev/serviceBinding',
        name: '/pages/dev/serviceBinding',
        component: () => import('@/views/dev/serviceBinding.vue')
    },
    {
        path: '/pages/dev/serviceImplManage',
        name: '/pages/dev/serviceImplManage',
        component: () => import('@/views/dev/serviceImplManage.vue')
    },
    {
        path: '/pages/dev/menuManage',
        name: '/pages/dev/menuManage',
        component: () => import('@/views/dev/menuManage.vue')
    },
    {
        path: '/pages/dev/reportCustomComponentFooterManage',
        name: '/pages/dev/reportCustomComponentFooterManage',
        component: () => import('@/views/dev/reportCustomComponentFooterManage.vue')
    },
    {
        path: '/pages/dev/reportCustomComponentManage',
        name: '/pages/dev/reportCustomComponentManage',
        component: () => import('@/views/dev/reportCustomComponentManage.vue')
    },
    {
        path: '/pages/dev/reportCustomComponentRelManage',
        name: '/pages/dev/reportCustomComponentRelManage',
        component: () => import('@/views/dev/reportCustomComponentRelManage.vue')
    },
    {
        path: '/pages/dev/reportCustomGroupManage',
        name: '/pages/dev/reportCustomGroupManage',
        component: () => import('@/views/dev/reportCustomGroupManage.vue')
    },
    {
        path: '/pages/dev/reportCustomManage',
        name: '/pages/dev/reportCustomManage',
        component: () => import('@/views/dev/reportCustomManage.vue')
    },
    {
        path: '/pages/dev/jobManage',
        name: '/pages/dev/jobManage',
        component: () => import('@/views/dev/jobManage.vue')
    },
    {
        path: '/pages/dev/listDemo',
        name: '/pages/dev/listDemo',
        component: () => import('@/views/dev/listDemo.vue')
    },
    {
        path: '/pages/dev/mappingDomainManage',
        name: '/pages/dev/mappingDomainManage',
        component: () => import('@/views/dev/mappingDomainManage.vue')
    },
    {
        path: '/pages/dev/mappingManage',
        name: '/pages/dev/mappingManage',
        component: () => import('@/views/dev/mappingManage.vue')
    },
    {
        path: '/pages/dev/menuCatalogManage',
        name: '/pages/dev/menuCatalogManage',
        component: () => import('@/views/dev/menuCatalogManage.vue')
    },
    {
        path: '/pages/dev/menuGroupCatalogManage',
        name: '/pages/dev/menuGroupCatalogManage',
        component: () => import('@/views/dev/menuGroupCatalogManage.vue')
    },
    {
        path: '/pages/dev/menuGroupManage',
        name: '/pages/dev/menuGroupManage',
        component: () => import('@/views/dev/menuGroupManage.vue')
    },
    {
        path: '/pages/dev/componentConditionManage',
        name: '/pages/dev/componentConditionManage',
        component: () => import('@/views/dev/componentConditionManage.vue')
    },
    {
        path: '/pages/dev/configMenu',
        name: '/pages/dev/configMenu',
        component: () => import('@/views/dev/configMenu.vue')
    },
    {
        path: '/pages/dev/devServiceProvide',
        name: '/pages/dev/devServiceProvide',
        component: () => import('@/views/dev/devServiceProvide.vue')
    },
    {
        path: '/pages/dev/dictManage',
        name: '/pages/dev/dictManage',
        component: () => import('@/views/dev/dictManage.vue')
    },
    {
        path: '/pages/dev/InitializeCommunityManage',
        name: '/pages/dev/InitializeCommunityManage',
        component: () => import('@/views/dev/InitializeCommunityManage.vue')
    },
    {
        path: '/pages/dev/businessDatabusManage',
        name: '/pages/dev/businessDatabusManage',
        component: () => import('@/views/dev/businessDatabusManage.vue')
    },
    {
        path: '/pages/dev/businessTableHisManage',
        name: '/pages/dev/businessTableHisManage',
        component: () => import('@/views/dev/businessTableHisManage.vue')
    },
    {
        path: '/pages/dev/cacheManage',
        name: '/pages/dev/cacheManage',
        component: () => import('@/views/dev/cacheManage.vue')
    },
    {
        path: '/pages/dev/appManage',
        name: '/pages/dev/appManage',
        component: () => import('@/views/dev/appManage.vue')
    },
    {
        path: '/pages/dev/attrSpecManage',
        name: '/pages/dev/attrSpecManage',
        component: () => import('@/views/dev/attrSpecManage.vue')
    },
    {
        path: '/pages/dev/attrValueManage',
        name: '/pages/dev/attrValueManage',
        component: () => import('@/views/dev/attrValueManage.vue')
    },
    {
        path: '/pages/dev/basePrivilegeManage',
        name: '/pages/dev/basePrivilegeManage',
        component: () => import('@/views/dev/basePrivilegeManage.vue')
    },
    {
        path: '/pages/dev/privilege',
        name: '/pages/dev/privilege',
        component: () => import('@/views/dev/privilege.vue')
    },
    {
        path: '/pages/dev/addRoute',
        name: '/pages/dev/addRoute',
        component: () => import('@/views/dev/addRoute.vue')
    }
] 